import React from 'react';
import Wrap from './Wrap';
import voca from 'voca';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import useStores from '../../../utils/useStores';

const DepiSection = () => {
  const { dataStore } = useStores();
  return (
    <Wrap>
      <Box mb={4}>
        <Typography color="primary" variant="h2" align="center">
          Das Deutsche Pelletinstitut
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          <Box
            component="img"
            src="/images/DEPI_Logo.svg"
            margin="auto"
            display="block"
            mb={4}
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Box mb={4}>
            <Typography variant="h6">
              Das DEPI bündelt die Bereiche Kommunikation,
              Verbraucherinformation, PR und Marketing rund um das Thema Heizen
              mit Holzpellets. Zudem sichert es die Brennstoffqualität mit der
              Zertifizierung EN<i>plus</i> und die Fortbildung im Handwerk mit
              den Schulungen zum Pelletfachbetrieb und Fachstudio
              Pelletkaminofen.
            </Typography>
          </Box>
          <Hidden smDown implementation="css">
            <Button
              href="https://depi.de"
              target="_blank"
              color="secondary"
              size="large"
            >
              Zum DEPI
            </Button>
          </Hidden>
          <Hidden mdUp implementation="css">
            <Box
              fullWidth
              component={Button}
              href="https://depi.de"
              target="_blank"
              color="secondary"
              size="large"
            >
              Zum DEPI
            </Box>
          </Hidden>
        </Grid>
      </Grid>
    </Wrap>
  );
};

export default DepiSection;
